import React, { useEffect, useState } from 'react';

const ScrollToTopButton: React.FC = () => {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (!showButton) return null;

    return (
        <div style={containerStyle}>
            <button onClick={scrollToTop} style={buttonStyle}>
                <div style={{ marginBottom: '4px' }}>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.54467 0.223769L11.6007 5.27966C11.745 5.42399 11.8242 5.61634 11.8242 5.82145C11.8242 6.02678 11.7449 6.21902 11.6007 6.36335L11.1415 6.82238C10.9974 6.96659 10.805 7.04604 10.5997 7.04604C10.3946 7.04604 10.1957 6.96659 10.0516 6.82238L7.09556 3.87285L7.09556 13.2437C7.09556 13.6662 6.7648 14 6.34218 14H5.69307C5.27045 14 4.90634 13.6662 4.90634 13.2437L4.90634 3.83938L1.93381 6.82227C1.78949 6.96648 1.60225 7.04593 1.39703 7.04593C1.19204 7.04593 1.00208 6.96648 0.857868 6.82227L0.400198 6.36323C0.255874 6.21891 0.177224 6.02667 0.177224 5.82133C0.177224 5.61623 0.256898 5.42387 0.401221 5.27955L5.45712 0.223656C5.6019 0.07899 5.79516 -0.000569344 6.00061 -9.53674e-07C6.20674 -0.000455856 6.40012 0.07899 6.54467 0.223769Z" fill="#277871"/>
                    </svg>

                </div>

                <span>Наверх</span>
            </button>
        </div>
    );
};

const containerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '150px', // расстояние снизу от содержимого
};

const buttonStyle: React.CSSProperties = {
    color: '#136f63',
    border: 'none',
    padding: '10px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '14px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

export default ScrollToTopButton;
